import QueryString from "query-string";
import { all, call, put, select, takeEvery } from "redux-saga/effects";
import api from "../../utils/api";
import { errorAlert } from "../Alerts/actions";
import {
  getPreDataFailure,
  getPreDataSuccess,
  savePreFailure,
  savePreSuccess,
} from "./actions";
import { GET_PRE_DATA, SAVE_PRE } from "./constants";

export function* getPreDataSaga({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const { data } = yield call(
      api(token).get,
      `/api/pre-admission-assessment/${payload}`
    );
    yield put(getPreDataSuccess(data));
  } catch (e) {
    yield put(getPreDataFailure());
  }
}

export function* savePreSaga({ payload, onSave }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const { data } = yield call(
      api(token).post,
      `/api/pre-admission-assessment/add`,
      payload
    );
    yield put(savePreSuccess(data));
    typeof onSave === "function" && onSave();
  } catch (e) {
    yield put(savePreFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
    else if (e.message !== undefined)
      yield put(errorAlert("Error while saving data!"));
  }
}

export function* getPreDataFlow() {
  yield takeEvery(GET_PRE_DATA, getPreDataSaga);
}
export function* savePreFlow() {
  yield takeEvery(SAVE_PRE, savePreSaga);
}

export default function* PreSaga() {
  yield all([getPreDataFlow(), savePreFlow()]);
}
